function ClanWarning() {
  return <h1>경고명단</h1>;
}

export default ClanWarning;
